import { PricesActions, PricesActionTypes } from '../actions/prices.actions';
import { Order } from '@cemex-core/cmx-api/models/order-management/order';
import { OrderBuilderActions, RESET_BUILDER } from '../../../actions/order-builder.actions';
import { PricesPatchResponse } from '@cemex-core/cmx-api/models/prices/prices-patch-res';

export interface PricesState {
  loading: boolean;
  pricesResponse: PricesPatchResponse;
  orderDetail: Order;
}

export const initialState: PricesState = {
  loading: false,
  pricesResponse: null,
  orderDetail: null,
};

export function pricesReducer(state = initialState, action: PricesActions | OrderBuilderActions): PricesState {
  switch (action.type) {
    case PricesActionTypes.LOAD: {
      return {
        ...state,
        ...initialState,
        loading: true,
      } as PricesState;
    }
    case PricesActionTypes.LOAD_COMPLETE: {
      return {
        ...state,
        loading: false,
        pricesResponse: action.payload,
      } as PricesState;
    }
    case PricesActionTypes.LOAD_ORDER_DETAIL_COMPLETE: {
      return {
        ...state,
        orderDetail: action.payload,
      } as PricesState;
    }
    case RESET_BUILDER:
    case PricesActionTypes.RESET: {
      return {
        ...initialState,
      };
    }
    default: {
      return state;
    }
  }
}
